import $ from "jquery";

import matchHeight from "jquery-match-height";
import { zip } from "lodash";

$(document).ready(function() {
  $(".read-more-text").each(function() {
    const test = $(this).html();

    $("p:has(strong)").css("font-weight", "900");
    $("p:has(em)").css("font-style", "italic");

    const Class = $(this)
      .attr("class")
      .replace("read-more-text ", "");

    const maxLength = Class;
    var myStr = $(this).text();
    if ($.trim(myStr).length > maxLength) {
      var newStr = myStr.substring(0, maxLength);
      var removedStr = myStr.substring(maxLength, $.trim(myStr).length);
      $(this)
        .empty()
        .html(newStr);
      $(this).append(
        ' <a href="javascript:void(0);" class="read-more">... Czytaj więcej</a>'
      );
      $(this).append('<span class="more-text">' + removedStr + "</span>");
      $(this).append(
        ' <a href="javascript:void(1);" class="read-less" style="display: none;"> Czytaj mniej</a>'
      );
    }
  });
  $(".read-more").click(function() {
    $(this)
      .siblings(".more-text")
      .toggleClass("inline");
    $(this).hide();
    $(this)
      .siblings(".read-less")
      .show();
  });
  $(".read-less").click(function() {
    $(this)
      .siblings(".more-text")
      .toggleClass("inline");
    $(this).hide();
    $(this)
      .siblings(".read-more")
      .show();
  });
});

$(function() {
  var mobileViewport = window.matchMedia("screen and (min-width: 1200px)");

  $(".sale-item__preview").matchHeight({
    property: "min-height"
  });
  $(".heading--match").matchHeight({
    property: "min-height"
  });
  if (mobileViewport.matches) {
    $(".company-info__image").matchHeight({
      target: $(".company-info__content ")
    });
  }
});

// export function match(){
// matchHeight(document.querySelectorAll('.sale-item__preview'), {
//     property: 'min-height'
// });
// }
